import { SvgIcon } from '@mui/material';
import { motion } from 'motion/react';
import { forwardRef } from 'react';

import type { AnimatedIconProps, AnimeatableIconRef } from './types';
import { pathVariants } from './types';
import { useAnimatedIcon } from './useAnimatedIcon';

const Building2Icon = forwardRef<AnimeatableIconRef, AnimatedIconProps>(
  ({ size = 28, strokeWidth = 2, titleAccess, color }, ref) => {
    const controls = useAnimatedIcon(ref);

    return (
      <SvgIcon
        titleAccess={titleAccess}
        color={color}
        sx={{ width: size, height: size }}
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <motion.path
            variants={pathVariants}
            initial="visible"
            animate={controls}
            custom={0}
            d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z"
          />
          <motion.path
            variants={pathVariants}
            initial="visible"
            animate={controls}
            custom={1}
            d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2"
          />
          <motion.path
            variants={pathVariants}
            initial="visible"
            animate={controls}
            custom={2}
            d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2"
          />
          <motion.path
            variants={pathVariants}
            initial="visible"
            animate={controls}
            custom={3}
            d="M10 6h4"
          />
          <motion.path
            variants={pathVariants}
            initial="visible"
            animate={controls}
            custom={4}
            d="M10 10h4"
          />
          <motion.path
            variants={pathVariants}
            initial="visible"
            animate={controls}
            custom={5}
            d="M10 14h4"
          />
          <motion.path
            variants={pathVariants}
            initial="visible"
            animate={controls}
            custom={6}
            d="M10 18h4"
          />
        </svg>
      </SvgIcon>
    );
  }
);

Building2Icon.displayName = 'Building2Icon';

export { Building2Icon };
